import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const MarketTicker = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const cryptoData = [
    { symbol: "BTC", name: "Bitcoin", price: "$42,856.32", change: "+2.45%", isPositive: true, icon: "Bitcoin" },
    { symbol: "ETH", name: "Ethereum", price: "$2,234.18", change: "+1.82%", isPositive: true, icon: "Coins" },
    { symbol: "ADA", name: "Cardano", price: "$0.5847", change: "-0.34%", isPositive: false, icon: "DollarSign" },
    { symbol: "SOL", name: "Solana", price: "$98.42", change: "+5.67%", isPositive: true, icon: "TrendingUp" },
    { symbol: "DOT", name: "Polkadot", price: "$7.23", change: "+0.89%", isPositive: true, icon: "Circle" },
    { symbol: "MATIC", name: "Polygon", price: "$0.8934", change: "-1.23%", isPositive: false, icon: "Hexagon" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % cryptoData?.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [cryptoData?.length]);

  return (
    <div className="bg-[var(--color-card)] border-b border-[var(--color-border)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between gap-4 overflow-x-auto">
          <div className="flex items-center gap-2 flex-shrink-0">
            <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-semibold text-[var(--color-foreground)]">Live Market</span>
          </div>
          
          <div className="flex items-center gap-4 md:gap-6 lg:gap-8 overflow-x-auto">
            {cryptoData?.map((crypto, index) => (
              <div 
                key={crypto?.symbol}
                className={`flex items-center gap-2 md:gap-3 flex-shrink-0 transition-opacity duration-500 ${
                  index === currentIndex ? 'opacity-100' : 'opacity-50'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name={crypto?.icon} size={16} color="var(--color-muted-foreground)" />
                  <span className="text-xs md:text-sm font-medium text-[var(--color-foreground)] whitespace-nowrap">
                    {crypto?.symbol}
                  </span>
                </div>
                <span className="text-xs md:text-sm font-semibold text-[var(--color-foreground)] whitespace-nowrap">
                  {crypto?.price}
                </span>
                <span className={`text-xs md:text-sm font-medium whitespace-nowrap ${
                  crypto?.isPositive ? 'text-[var(--color-success)]' : 'text-[var(--color-error)]'
                }`}>
                  {crypto?.change}
                </span>
              </div>
            ))}
          </div>
          
          <button className="flex-shrink-0 text-xs md:text-sm text-[var(--color-primary)] hover:underline font-medium">
            View All
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketTicker;